import styled, { css } from 'styled-components';

const afterCss = css`
  &::after {
    content: '▾';
    display: inline-block;
    margin-left: 4px;
    font-size: 18px;
    color: rgb(24, 83, 53);
  }
`;

const callToActionCss = css`
  font-weight: bold;
  color: rgb(24, 83, 53);
`;

const isActiveCss = css`
  background-color: rgb(24, 83, 53);
  color: #fff !important;

  &:hover {
    background-color: rgb(24, 83, 53);
  }
`;

export const LinkContainer = styled.div`
  font-size: 1rem;
  position: relative;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  transition: all ease 0.3s;
  display: flex;
  align-items: center;

  &:hover {
    background-color: #dfe1e5;
  }

  .label {
    position: absolute;
    right: -10px;
    top: -10px;
    padding: 2px 6px;
    border-radius: 16px;
    font-size: 0.61rem;
    background-color: rgb(24, 83, 53);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  ${({ hasSubMenu }) => hasSubMenu && afterCss}
  ${({ callToAction }) => callToAction && callToActionCss}
  ${({ isActive }) => isActive && isActiveCss}
`;
